<template>
  <div class="container">
    <login-component></login-component>
    <!-- Modal -->
    <div aria-hidden="true" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="myModal" class="modal fade">
      <login-restore-component></login-restore-component>
    </div>
    <!-- modal -->
  </div>
</template>

<script>

import Vue from 'vue';

import LoginComponent from './login/LoginComponent.vue';
import LoginRestoreComponent from './login/LoginRestoreComponent.vue';

export default {
  components: {
    'login-component': LoginComponent,
    'login-restore-component': LoginRestoreComponent,
  },
  mounted() {
    console.log('Component mounted.');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login.vue